/**
 * 检索类型-普通检索
 */
const SEARCH_NORMAL = 'normal';

/**
 * 检索类型-高级检索
 */
const SEARCH_ADVANCED = 'advanced';


export {
    SEARCH_NORMAL,
    SEARCH_ADVANCED
}
